module.exports = __webpack_public_path__ + "img/normal_u41.772f8d64.png";